import { useI18n } from "../i18n/LanguageContext";
import { WHATSAPP_URL, trackWhatsAppConversion } from "../data/mediaAssets";

const FloatingWhatsApp = () => {
    const { t } = useI18n();
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackWhatsAppConversion}
            aria-label={t.misc.whatsapp_float}
            data-testid="floating-whatsapp"
            className="fixed bottom-6 right-6 z-50 flex items-center gap-3 group"
        >
            <span className="hidden md:inline-block bg-brand-navy text-white font-sans text-xs uppercase tracking-widest px-4 py-2 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all">
                {t.misc.whatsapp_float}
            </span>
            <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#25D366] text-white rounded-full shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform">
                <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
                <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M20.52 3.48A11.9 11.9 0 0012.05 0C5.5 0 .16 5.34.16 11.88c0 2.09.55 4.13 1.6 5.93L0 24l6.34-1.66a11.86 11.86 0 005.7 1.45h.01c6.55 0 11.88-5.34 11.88-11.88 0-3.17-1.23-6.15-3.41-8.43zM12.05 21.8h-.01a9.9 9.9 0 01-5.05-1.38l-.36-.21-3.76.99 1-3.67-.24-.38a9.85 9.85 0 01-1.5-5.27c0-5.44 4.43-9.87 9.88-9.87 2.64 0 5.12 1.03 6.98 2.9a9.83 9.83 0 012.9 6.98c0 5.45-4.43 9.88-9.88 9.88zm5.42-7.4c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.36.22-.66.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.64-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.44-.53.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.64-.94-2.24-.25-.6-.5-.52-.68-.53l-.58-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.5 1.7.64.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z" />
                </svg>
            </span>
        </a>
    );
};

export default FloatingWhatsApp;
